// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-93746c9c]{display:flex;gap:20px;align-items:center;justify-content:center}.dot[data-v-93746c9c]{width:8px;height:8px;background-color:#ff2d55;border-radius:50%;animation:bounce-data-v-93746c9c 1s ease-in-out infinite}.dot[data-v-93746c9c]:nth-child(2){animation-delay:.2s}.dot[data-v-93746c9c]:nth-child(3){animation-delay:.4s}@keyframes bounce-data-v-93746c9c{0%,to{transform:scale(1)}50%{transform:scale(2.5)}}", ""]);
// Exports
module.exports = exports;
